import { SVGProps } from 'react';

const TextQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 6H3m18 6H8m13 6H8m-5-6v6"
    />
  </svg>
);
export default TextQuote;
